import { render, staticRenderFns } from "./SingleProccess.vue?vue&type=template&id=f16343b8&"
import script from "./SingleProccess.vue?vue&type=script&setup=true&lang=js&"
export * from "./SingleProccess.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports